import { createStackNavigator } from "@react-navigation/stack";
import Login from "../screens/auth/Login";
import React from "react";
import { observer } from "mobx-react";

const Auth = createStackNavigator();

const options = { headerShown: false };

const AuthNavigator = observer(() => {
  return (
    <Auth.Navigator>
      {/* <Auth.Screen name="options" component={Options} options={options} /> */}
      <Auth.Screen name="login" component={Login} options={options} />
    </Auth.Navigator>
  );
});

export default AuthNavigator;
